module.exports = __webpack_public_path__ + "img/adv_stable.e28c91f3.png";